<template>
    <v-dialog
        lazy
        :value="open"
        class="study-form"
        content-class="study-plan__event-dialog"
        max-width="636px"
        @input="closeFormHandle"
    >
        <v-card>
            <v-card-title>
                <v-layout justify-end>
                    <v-btn icon @click="closeFormHandle">
                        <v-icon color="#4A4A4A">mdi-close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text class="study-form__padding">
                <h2 class="section-title study-form__title mb-4 mx-0">
                    {{ isUpdate ? $t('Обновить событие') : $t('Добавить событие') }}
                </h2>
                <label class="study-form__label">{{ $t('Тип события') }}</label>
                <v-layout column class="mb-2">
                    <v-select
                        v-model="form.eventType"
                        :items="eventTypeList"
                        item-text="label"
                        class="study-form__select"
                        full-width
                        size="small"
                        outline
                        item-value="value"
                    />
                    <span class="study-form__error-field">
                        {{ $v.form.eventType.$error ? $t('Поле обязательно') : '' }}
                    </span>
                </v-layout>
                <v-layout class="mb-2" align-baseline>
                    <v-layout column>
                        <label class="study-form__label">{{ $t('Дата') }}</label>
                        <v-layout align-baseline>
                            <v-layout class="mr-2" column>
                                <v-menu
                                    v-model="dateStartMenu"
                                    lazy
                                    offset-y
                                    full-width
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                >
                                    <template #activator="{ on }">
                                        <input-base
                                            v-mask="'##.##.####'"
                                            :value="form.dateStart"
                                            :can-edit="false"
                                            class="study-form__input"
                                            v-on="on"
                                        />
                                        <span class="study-form__error-field">
                                            {{ $v.form.dateStart.$error ? $t('Поле обязательно') : '' }}
                                        </span>
                                    </template>
                                    <v-date-picker
                                        v-model="formattedDateStart"
                                        class="study-form__event-date"
                                        :first-day-of-week="1"
                                        :locale="lang"
                                        :allowed-dates="isAllowedDateStart"
                                        no-title
                                    />
                                </v-menu>
                            </v-layout>
                            -
                            <v-layout class="ml-2" column>
                                <v-menu
                                    v-model="dateEndMenu"
                                    lazy
                                    offset-y
                                    full-width
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                >
                                    <template #activator="{ on }">
                                        <input-base
                                            v-mask="'##.##.####'"
                                            :value="form.dateEnd"
                                            :can-edit="false"
                                            class="study-form__input"
                                            v-on="on"
                                        />
                                        <span class="study-form__error-field">
                                            {{ $v.form.dateEnd.$error ? $t('Поле обязательно') : '' }}
                                        </span>
                                    </template>
                                    <v-date-picker
                                        v-model="formattedDateEnd"
                                        class="study-form__event-date"
                                        :first-day-of-week="1"
                                        :locale="lang"
                                        :allowed-dates="isAllowedDateEnd"
                                        no-title
                                    />
                                </v-menu>
                            </v-layout>
                        </v-layout>
                    </v-layout>
                    <v-layout class="ml-4" column>
                        <label class="study-form__label">{{ $t('Время начала') }}</label>
                        <v-menu
                            v-model="timeMenu"
                            lazy
                            offset-y
                            full-width
                            :close-on-content-click="false"
                            transition="scale-transition"
                        >
                            <template #activator="{ on }">
                                <input-base
                                    v-mask="'##:##'"
                                    :value="form.time"
                                    :can-edit="false"
                                    class="study-form__input"
                                    v-on="on"
                                />
                                <span class="study-form__error-field">
                                    {{ $v.form.time.$error ? $t('Поле обязательно') : '' }}
                                </span>
                            </template>
                            <v-time-picker
                                v-model="form.time"
                                class="study-form__event-date"
                                format="24hr"
                                :locale="lang"
                            />
                        </v-menu>
                    </v-layout>
                </v-layout>
                <v-layout column>
                    <label class="study-form__label">{{ $t('Комментарий исполнителя') }}</label>
                    <text-area :value="form.comment" class="study-form__input" @input="inputCommentHandle" />
                </v-layout>
            </v-card-text>
            <v-card-actions class="study-form__padding">
                <v-layout class="study-form__actions">
                    <button-white
                        class="study-form__btn"
                        @click.native="closeFormHandle"
                    >
                        {{ $t("Отмена") }}
                    </button-white>
                    <button-red
                        class="study-form__btn"
                        @click.native="submitForm"
                    >
                        {{ $t("Сохранить") }}
                    </button-red>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import dayjs from 'dayjs';
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';
import InputBase from '@/components/ui/inputs/base/input';
import TextArea from '@/components/ui/inputs/base/textarea.vue';
import ButtonRed from '@/components/ui/buttons/button_red.vue';
import ButtonWhite from '@/components/ui/buttons/button_bd_white.vue';
import {mapGetters} from 'vuex';

export default {
  name      : 'StudyPlanEventForm',
  components: {
    ButtonWhite,
    TextArea,
    ButtonRed,
    InputBase,
  },
  mixins: [validationMixin],
  validations() {
    return {
      form: {
        dateStart: {
          required,
        },
        dateEnd: {
          required,
        },
        eventType: {
          required,
        },
        time: {
          required,
        },
      },
    };
  },
  props: {
    open: {
      type   : Boolean,
      default: false,
    },
    isUpdate: {
      type   : Boolean,
      default: false,
    },
    eventTypeList: {
      type   : Array,
      default: () => [],
    },
    eventData: {
      type   : Object,
      default: () => ({
        dateStart: '',
        dateEnd  : '',
        time     : '08:00',
        comment  : '',
        eventType: '',
      }),
    },
  },
  data: () => ({
    dateStartMenu: false,
    dateEndMenu  : false,
    timeMenu     : false,
    form         : {
      dateStart: '',
      dateEnd  : '',
      time     : '08:00',
      comment  : '',
      eventType: '',
    },
  }),
  computed: {
    ...mapGetters('study_plan', ['get_disabled_dates', 'get_events']),
    ...mapGetters('profile/general', ['lang']),
    nearestForwardEventFromStart() {
      const formattedDateStart = this.formatDate(this.form.dateStart);
      const eventDates = Object.keys(this.get_events).sort();
      const formattedLastEventDate = dayjs(eventDates[eventDates.length - 1]);
      let nearestEvent = null;
      let countDays = 0;
      while (
        !nearestEvent &&
        formattedLastEventDate &&
        formattedDateStart.isBefore(formattedLastEventDate)
      ) {
        const date = formattedDateStart.add(countDays, 'day');
        if (this.get_events[date.format('YYYY.MM.DD')]) {
          nearestEvent = date;
        }
        countDays += 1;
      }
      return nearestEvent;
    },
    nearestBackEventFromStart() {
      const formattedDateStart = this.formatDate(this.form.dateStart);
      const eventDates = Object.keys(this.get_events).sort();
      const formattedFirstEventDate = dayjs(eventDates[0]);
      let nearestEvent = null;
      let countDays = 0;
      while (
        !nearestEvent &&
        formattedFirstEventDate &&
        formattedDateStart.isAfter(formattedFirstEventDate)
      ) {
        const date = formattedDateStart.add(-countDays, 'day');
        if (this.get_events[date.format('YYYY.MM.DD')]) {
          nearestEvent = date;
        }
        countDays += 1;
      }
      return nearestEvent;
    },
    formattedDateStart: {
      get() {
        if (this.form.dateStart) {
          return this.formatDate(this.form.dateStart).toISOString().substr(0, 10);
        }
        return new Date().toISOString().substr(0, 10);
      },
      set(value) {
        this.form.dateStart = dayjs(value).format('DD.MM.YYYY');
      },
    },
    formattedDateEnd: {
      get() {
        if (this.form.dateEnd) {
          return this.formatDate(this.form.dateEnd).toISOString().substr(0, 10);
        }
        return new Date().toISOString().substr(0, 10);
      },
      set(value) {
        this.form.dateEnd = dayjs(value).format('DD.MM.YYYY');
      },
    },
  },
  watch: {
    eventData: function(newEventData) {
      this.form = {...newEventData};
    },
  },
  methods: {
    formatDate(value) {
      const date = value.split('.');
      return dayjs()
          .set('date', +date[0])
          .set('month', +date[1] - 1)
          .set('year', +date[2]);
    },
    isAllowedDate(val) {
      const formattedDate = dayjs(val).format('YYYY.MM.DD');
      const formattedDate2 = dayjs(val).format('DD.MM.YYYY');
      const isOnlyCurrentEvent = !this.get_events[formattedDate] ||
        this.get_events[formattedDate].id === this.form.id;

      return !this.get_disabled_dates.includes(formattedDate) &&
        (dayjs(val).isAfter(dayjs()) || this.form.dateStart === formattedDate2) &&
        isOnlyCurrentEvent;
    },
    isAllowedDateStart(val) {
      const formattedDateEnd = this.formatDate(this.form.dateEnd);
      const isBeforeOrEqualEndDate = dayjs(val).isBefore(formattedDateEnd) ||
        dayjs(val).format('DD.MM.YYYY') === this.form.dateEnd;

      return this.isAllowedDate(val) &&
        isBeforeOrEqualEndDate &&
        (!this.nearestBackEventFromStart || dayjs(val).isAfter(this.nearestBackEventFromStart));
    },
    isAllowedDateEnd(val) {
      const formattedDateStart = this.formatDate(this.form.dateStart);
      const isAfterOrEqualStartDate = dayjs(val).isAfter(formattedDateStart) ||
        dayjs(val).format('DD.MM.YYYY') === this.form.dateStart;

      return this.isAllowedDate(val) &&
        isAfterOrEqualStartDate &&
        (!this.nearestForwardEventFromStart || dayjs(val).isBefore(this.nearestForwardEventFromStart));
    },
    inputCommentHandle(e) {
      this.form.comment = e.target.value;
    },
    closeFormHandle() {
      this.$emit('close');
      this.$v.$reset();
    },
    submitForm() {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.$emit('submit', this.form);
        this.form = {...this.eventData};
        this.closeFormHandle();
      }
    },
  },
};
</script>

<style lang="less">
.study-plan__event-dialog:not(.v-dialog--fullscreen) {
  & .v-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    & .v-card__text {
      overflow: auto;
      max-height: 60vh;
      flex: 1;
    }
  }
}
</style>
